var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99989 16.1145C5.31656 16.1145 2.32739 13.1183 2.32739 9.44204C2.32739 8.11745 2.71698 6.83537 3.45364 5.73037C3.61656 5.48954 3.94948 5.4187 4.19031 5.58162C4.43114 5.74454 4.50198 6.07745 4.33906 6.31829C3.72281 7.23912 3.39698 8.32287 3.39698 9.43495C3.39698 12.5304 5.91156 15.045 9.00698 15.045C12.1024 15.045 14.617 12.5304 14.617 9.43495C14.617 6.33954 12.0953 3.82495 8.99989 3.82495C8.34823 3.82495 7.71073 3.91704 7.10864 4.1012C6.82531 4.1862 6.52781 4.03037 6.44281 3.74704C6.35781 3.4637 6.51364 3.1662 6.79698 3.0812C7.50531 2.8687 8.24198 2.75537 8.99989 2.75537C12.6832 2.75537 15.6724 5.75162 15.6724 9.42787C15.6724 13.1041 12.6832 16.1145 8.99989 16.1145Z",
    fill: "#1D244A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07451 4.29959C5.9541 4.29959 5.8266 4.25709 5.72743 4.17209C5.50076 3.97375 5.47951 3.64084 5.67076 3.42125L7.71784 1.06959C7.90909 0.850004 8.2491 0.821671 8.46868 1.02C8.68826 1.21125 8.70951 1.55125 8.51826 1.77084L6.47118 4.11542C6.36493 4.23584 6.21618 4.29959 6.07451 4.29959Z",
    fill: "#1D244A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46178 6.04209C8.35553 6.04209 8.2422 6.00667 8.15011 5.94292L5.75595 4.19334C5.5222 4.02334 5.47261 3.69042 5.64261 3.45667C5.81261 3.21584 6.14553 3.16626 6.38636 3.33626L8.77345 5.07876C9.0072 5.24876 9.06387 5.58167 8.88678 5.82251C8.78762 5.97126 8.6247 6.04209 8.46178 6.04209Z",
    fill: "#1D244A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/rotate-left.53b4ee1bce75d191b452165359bd8554.svg";
export { ForwardRef as ReactComponent };